import * as React from 'react';
import ResizeObserver from 'resize-observer-polyfill';
export const useResizeObserver = ({ ref, callback, dep, }) => {
    React.useLayoutEffect(() => {
        if (!ref?.current) {
            return;
        }
        const ro = new ResizeObserver((entries) => {
            for (const entry of entries) {
                callback(entry);
            }
        });
        ro.observe(ref.current);
        return () => {
            ref.current && ro.unobserve(ref.current);
        };
    }, dep ?? []);
};
//# sourceMappingURL=useResizeObserver.js.map